var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 140.14 36.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #414042;\n      }\n\n      .cls-4 {\n        fill: #232e65;\n      }\n\n      .cls-5 {\n        fill: #be1e2d;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.37 31.87 24.37 31.87 14.74 22.24 6.23 22.24 20.11 36.12 24.37 36.12 24.37 31.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.73 4.26 32.73 4.26 14.74 22.24 6.23 22.24 28.47 0 32.73 0 32.73 4.26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.03,
    y: 22.56,
    width: 1.5,
    height: 15.95,
    transform: "translate(-16.09 22.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.44 18.07 25.49 35.11 26.02 34.58 26.55 34.05 9.5 17 8.44 18.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.24,
    y: 18.04,
    width: 1.5,
    height: 7.41,
    transform: "translate(-12.45 13.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "5.02 21.03 22.29 38.3 23.36 37.24 6.31 20.19 5.02 21.03"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.97 26.95 9.5 27.48 14.74 22.24 13.68 21.18 8.44 26.42 8.97 26.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14.21 20.64 14.74 21.18 15.27 21.71 23.6 13.38 22.54 12.32 14.21 20.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6.84 24.82 7.37 25.35 7.91 25.88 22.01 11.79 20.94 10.72 6.84 24.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "11.03 17.45 11.56 17.98 12.09 18.51 20.41 10.19 19.88 9.66 19.35 9.13 11.03 17.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24.13 12.85 34.91 2.07 34.38 1.54 33.84 1.01 23.07 11.79 24.13 12.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "22.54 11.25 33.31 .48 32.78 -.05 32.25 -.59 21.47 10.19 22.54 11.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "19.88 8.59 20.94 9.66 31.72 -1.12 31.18 -1.65 30.65 -2.18 19.88 8.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.49 17.98 5.25 23.22 5.78 23.76 6.31 24.29 11.56 19.04 10.49 17.98"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.75,27.05v-4.81h10.51v4.81h-10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m38.66,36.13h-5.93V8.04h10.63c7.18,0,9.35,4.3,9.35,8.77,0,6.75-3.68,10.24-10.98,10.24h-3.06v9.08Zm2.41-13.89c3.06,0,5.51-.89,5.51-5,0-3.61-2.13-4.38-5.04-4.38h-2.87v9.39h2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m59.69,31.08h12.53v5.04h-18.5V8.04h17.8v5h-11.83v6.59h11.13v4.89h-11.13v6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m92.09,36.13h-5.86v-12.8c0-2.17-.85-3.1-2.68-3.1-1.59,0-3.18.89-3.96,1.59v14.31h-5.86V15.92h5.2l.31,2.02c1.47-1.36,3.68-2.44,6.44-2.44,4.46,0,6.4,2.21,6.4,6.83v13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.06,15.14c0,5.86,14.58,2.25,14.58,12.57,0,6.36-5.16,8.88-10.74,8.88-5.04,0-10.36-1.63-10.86-8.92l5.43-.81c.47,2.71,1.47,5,5.59,5,2.48,0,4.65-.85,4.65-3.45,0-5.86-14.62-1.78-14.62-12.41,0-5.47,4.58-8.46,10.24-8.46,5,0,9.58,1.55,10.01,8.22l-5.47.62c-.23-2.64-1.32-4.23-4.62-4.23-2.87,0-4.19,1.2-4.19,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.21,8.04l9.93,28.08h-6.56l-2.33-6.83h-9.35l-2.17,6.83h-6.17l9.19-28.08h7.45Zm-3.68,5.62h-.15l-3.45,10.86h7.1l-3.49-10.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.93,27.32v8.81H0V8.04h5.93v12.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c448ed3a6166a6ee3b3116579d22e531.svg";
export { ForwardRef as ReactComponent };